import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');
const Button = videojs.getComponent('MenuButton');

class AIButton extends Button {
  constructor(player, options) {
    super(player, options);
    const self = this;

    this.options = {...options};

    if ((options?.ai || '') === '') {
      return;
    }

    this.addClass('scaleup-ai');
    this.setAttribute('id', this.player_.id() + '-scaleup-ai');
    this.controlText('Inteligência Artificial');

    const aiIcon = videojs.dom.createEl('i', {
      className: 'fa-solid fa-microchip-ai',
    });

    this.menuButton_.addClass('scaleup-ai-button');
    this.menuButton_.el().appendChild(aiIcon);
    // this.menuButton_.el().classList.add('vjs-icon-cog');

    let ul = document.createElement('ul');
    ul.className = 'vjs-menu-content scaleup-sm-top-level';
    ul.setAttribute('role', 'menu');
    ul.setAttribute('id', this.player_.id() + '-scaleup-ai-menu');

    const products = ['QUESTION', 'MIND_MAP', 'SUMMARY'];
    // const products = ['MIND_MAP', 'SUMMARY'];
    const productName = {
      'QUESTION': 'Perguntas',
      'MIND_MAP': 'Mapa Mental',
      'SUMMARY': 'E-Book',
    }

    const items = (options?.ai || '')
    .toString()
    .split(',')
    .filter(item => products.includes(item))
    .map(currentItem => {
      let item = document.createElement('li');
      item.setAttribute('data-component', currentItem);
      item.className = 'scaleup-list-item';
      item.innerHTML = `<div class="scaleup-list-item__left-wrapper">
        <span class="scaleup-list-item__left-wrapper__span">${productName[currentItem]}</span>
      </div>`;
      item.onclick = () => {
        self.handleClick(null);

        if (currentItem === 'MIND_MAP') {
          options.changeOpenedMindMap(true);
        } else if (currentItem === 'SUMMARY') {
          options.changeOpenedSummary(true);
        } else if (currentItem === 'QUESTION') {
          options.changeOpenedQuiz(true);
        }
      };

      return item;
    });

    this.menu.el().querySelector('ul').append(...items);
  }

  handleClick(event) {
    this.el().classList.toggle('vjs-toogle-btn');
    this.menu.el().classList.toggle('vjs-lock-open');

    if (event) {
      this.options.onLoadAI();
    }
  }
}

class AIProductsPlugin extends Plugin {
  constructor(player, options) {
    super(player);

    const self = this;

    this.options = {...options};

    this.player.ready(() => {
      if (this.options.ai === '') {
        return;
      }

      const products = (this.options.ai).split(',');

      if (products.indexOf('QUESTION') < 0 &&
      products.indexOf('MIND_MAP') < 0 &&
      products.indexOf('SUMMARY') < 0) {
        return;
      }

      // if (this.options.createSummaryButton) {
        this.player.addClass('scaleup-ai-button');
        this.registerButton();

        if ((this.options.ai).indexOf('search') > -1) {
          this.player
            .getChild('controlBar')
            .el()
            .insertBefore(
              this.player.getChild('controlBar').getChild('aiButton').el(),
              this.player.getChild('controlBar').getChild('searchButton').el()
            );
        } else if ((this.options.ai).indexOf('subtitles') > -1) {
          this.player
            .getChild('controlBar')
            .el()
            .insertBefore(
              this.player.getChild('controlBar').getChild('aiButton').el(),
              this.player.getChild('controlBar').getChild('subsCapsButton').el()
            );
        } else {
          this.player
            .getChild('controlBar')
            .el()
            .insertBefore(
              this.player.getChild('controlBar').getChild('aiButton').el(),
              this.player.getChild('controlBar').getChild('settingsMenuButton').el()
            );
        }
      // }
    });
  }

  registerButton() {
    videojs.registerComponent('aiButton', AIButton);

    this.player.getChild('controlBar').addChild('aiButton', this.options);

    this.buildUI();
  }

  buildUI() {
    // const summaryTextHeading = videojs.dom.createEl('div', {
    //   className: 'scaleup-summarytext-heading',
    // });

    // const mindMapHeading = videojs.dom.createEl('div', {
    //   className: 'scaleup-summarytext-heading',
    // });


    // const summaryTextPanel = videojs.dom.createEl('div', {
    //   className: 'scaleup-summarytext scaleup-panel',
    // });

    // const mindMapPanel = videojs.dom.createEl('div', {
    //   className: 'scaleup-mind-map scaleup-panel',
    // });

    // this.player.el().appendChild(summaryTextPanel);
    // this.player.el().appendChild(mindMapPanel);

    // this.player.el().appendChild(summaryTextPanel);
    // this.player.el().appendChild(mindMapPanel);

    // const summaryToggle = this.player.getChild('controlBar').getChild('summaryButton').el();

    // const switchEl = videojs.dom.createEl('div', {
    //   className: 'scaleup-summary scaleup-switch-wrapper',
    // });
    // const switchBG = videojs.dom.createEl('div', {
    //   className: 'scaleup-summary scaleup-switch-background',
    // });
    // const switchIcon = videojs.dom.createEl('i', {
    //   className: 'fa-solid fa-bolt',
    // });

    // if (!this.options.enableSummaryButton) {
    //   summaryToggle.classList.add('vjs-disabled');
    // }

    // switchBG.appendChild(switchIcon);
    // switchEl.appendChild(switchBG);
    // summaryToggle.appendChild(switchEl);
  }
}

AIProductsPlugin.defaultState = {};

videojs.registerPlugin('aiProducts', AIProductsPlugin);

export default AIProductsPlugin;
